import { useScrollReveal } from '../../hooks/useScrollReveal';
import { BLOG_POSTS } from '../../data/blog';
import { SiteButton } from '../site/SiteButton';
import { BlogPostCard } from './BlogPostCard';
import { BlogListItem } from './BlogListItem';

export function BlogShowcase() {
  const { ref: gridRef, visible: gridVisible } = useScrollReveal<HTMLElement>(0.08);
  const { ref: ctaRef, visible: ctaVisible } = useScrollReveal<HTMLElement>(0.18);

  const [featured, ...rest] = BLOG_POSTS;

  return (
    <div className="blog-showcase">
      <section ref={gridRef} className={`blog-feed${gridVisible ? ' is-visible' : ''}`}>
        <div className="container">
          <header className="blog-feed__head reveal-item">
            <h1 className="blog-feed__title">Blog</h1>
          </header>

          {featured ? <BlogPostCard post={featured} index={0} /> : null}

          {rest.length > 0 ? (
            <div className="blog-feed__more">
              <div className="blog-feed__tiles">
                {rest.map((post, index) => (
                  <BlogListItem key={post.slug} post={post} index={index} />
                ))}
              </div>
            </div>
          ) : null}
        </div>
      </section>

      <section ref={ctaRef} className={`blog-cta${ctaVisible ? ' is-visible' : ''}`}>
        <div className="container">
          <div className="blog-cta__card reveal-item">
            <h2>Ready to join Hello Gwiji?</h2>
            <p className="paragraph-02 text-dark-grey-two">
              Get early access to the platform and be first when we launch across every device.
            </p>
            <SiteButton href="/waitlist" variant="cta">
              Join the waitlist
            </SiteButton>
          </div>
        </div>
      </section>
    </div>
  );
}
